module.exports = __webpack_public_path__ + "static/media/15.1f44b717.png";